export default __webpack_public_path__ + "static/2-07af4702c69f982b1e973bceaafa19ec.png";